export const getWrappers = (state) => state?.wrappers?.list ?? [];
export const getResourceWrapperList = (recordId) => (state) =>
    state?.wrappers?.[`${recordId}_resource_wrapper_list`] || null;
